export const isValidSSID = (value: string): boolean => {
    const pattern = /^[A-Za-z0-9_-]{1,29}$/;

    return !(!value || value.length > 29 || /[æøåÆØÅ]/.test(value) || !pattern.test(value));
};

export const isValidWifiPassword = (value: string): boolean => {
    if (!value) {
        return true;
    }

    return !(value.length < 8 || value.length > 64 ||
        /[æøåÆØÅ]/.test(value) ||
        !/[A-Z]/.test(value) ||
        !/[a-z]/.test(value) ||
        !/[0-9]/.test(value) ||
        !/[!@#$%^&*(),.?":{}|<>_\-+=`~[\]\\';/]/.test(value));
};
